export class ResponseValidator {
    public ValidateResponse(response: any) {
        if (response === null || response === undefined) {
            return false;
        }

        return this.ValidateStatusCode(response.statusCode);
    }

    private ValidateStatusCode(statusCode: any) {
        if (statusCode === null || statusCode === undefined) {
            return true;
        }

        if (statusCode === 0) {
            return true;
        }

        if (statusCode >= 200 && statusCode < 300) {
            return true;
        }

        return false;
    }
}